function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import escapeRegExp from "../escape-reg-exp";
import { getRowTextValue } from "../product/getRowTextValue";
import formatDate from "../format-date";
export var basicTagReplacer = function(html, formValues) {
    var name = formValues.name, company = formValues.company, email = formValues.email, date = formValues.date, desiredStartDate = formValues.desiredStartDate, companyAddress = formValues.companyAddress, city = formValues.city, state = formValues.state, postalCode = formValues.postalCode, country = formValues.country;
    var newHtml = html;
    var newDate = date;
    if (!newDate) {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        newDate = "".concat(mm, "/").concat(dd, "/").concat(yyyy);
    }
    newHtml = tagReplacer(newHtml, "Name", name);
    newHtml = tagReplacer(newHtml, "Company", company);
    newHtml = tagReplacer(newHtml, "Email", email);
    newHtml = tagReplacer(newHtml, "Date", newDate || "-");
    newHtml = tagReplacer(newHtml, "Proposed Start Date", desiredStartDate || "-");
    newHtml = tagReplacer(newHtml, "street address", companyAddress || "-");
    newHtml = tagReplacer(newHtml, "city", city || "-");
    newHtml = tagReplacer(newHtml, "state", state || "-");
    newHtml = tagReplacer(newHtml, "postal code", postalCode || "-");
    newHtml = tagReplacer(newHtml, "country", country || "-");
    newHtml = tagReplacer(newHtml, "Page Break", '<div class="pagebreak" clear="all" style="page-break-before: always"></div>');
    newHtml = '<html>\n    <head>\n      <meta charset="UTF-8" />\n      <meta name="viewport" content="width=device-width" />\n      <title>Index</title>\n    </head>\n    <body>\n      '.concat(newHtml, "\n    </body>\n  </html>");
    return newHtml;
};
var buildRxTag = function(tag) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _isClosing = options.isClosing, isClosing = _isClosing === void 0 ? false : _isClosing, _withAngleBrackets = options.withAngleBrackets, withAngleBrackets = _withAngleBrackets === void 0 ? false : _withAngleBrackets, _shouldEscapeTag = options.shouldEscapeTag, shouldEscapeTag = _shouldEscapeTag === void 0 ? false : _shouldEscapeTag;
    var brackets = withAngleBrackets ? [
        "<",
        ">"
    ] : [
        "&lt;",
        "&gt;"
    ];
    var closer = isClosing ? "/" : "";
    if (shouldEscapeTag) tag = escapeRegExp(tag);
    return "".concat(brackets[0]).concat(closer).concat(tag).concat(brackets[1]);
};
var regexReplace = function(html, regex, replacerValue) {
    if (typeof replacerValue !== "function") {
        replacerValue = String(replacerValue).replace(/\$/g, "$$$$");
    }
    return html.replace(regex, replacerValue);
};
export var tagReplacer = function() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", tag = arguments.length > 1 ? arguments[1] : void 0, replacerValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    html = regexReplace(html, new RegExp(buildRxTag(tag, {
        isClosing: false,
        withAngleBrackets: true
    }), "g"), replacerValue);
    html = regexReplace(html, new RegExp(buildRxTag(tag), "g"), replacerValue);
    return html;
};
export var tagReplacer2 = function() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", tag = arguments.length > 1 ? arguments[1] : void 0, replacerValue = arguments.length > 2 ? arguments[2] : void 0, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var isWrapped = options.isWrapped, onlyStripTags = options.onlyStripTags, tagIsRegex = options.tagIsRegex, isCaseInsensitive = options.isCaseInsensitive;
    var tagOpts = {
        shouldEscapeTag: !tagIsRegex
    };
    var regexStr = buildRxTag(tag, tagOpts);
    if (isWrapped) {
        regexStr += "([\\s\\S]*?)" + buildRxTag(tag, _objectSpreadProps(_objectSpread({}, tagOpts), {
            isClosing: true
        }));
    }
    var flags = "g";
    if (isCaseInsensitive) flags += "i";
    var regex = new RegExp(regexStr, flags);
    if (isWrapped && onlyStripTags) {
        return html.replace(regex, "$1");
    }
    return regexReplace(html, regex, replacerValue);
};
/**
 * Convenience function to call tagReplacer2 for multiple replacements
 */ export var tagReplacerBulk = function(html, replacementsObject, options) {
    Object.entries(replacementsObject).forEach(function(param) {
        var _param = _slicedToArray(param, 2), tag = _param[0], replacerValue = _param[1];
        html = tagReplacer2(html, tag, replacerValue, options);
    });
    return html;
};
var defaultQuickReplaceFieldsWithDefaultImplementation = {
    currentDate: function() {
        return formatDate()(new Date());
    }
};
var defaultQuickReplaceFields = [
    "companyName",
    "companyAddress",
    "startDate",
    "saasFee",
    "discountPercent",
    "implementationDate", 
];
export var customSowTagReplacer = function(cart, newHtml) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _additionalQuickReplaceFields = ref.additionalQuickReplaceFields, additionalQuickReplaceFields = _additionalQuickReplaceFields === void 0 ? [] : _additionalQuickReplaceFields, _additionalQuickReplaceFieldsWithDefaultImplementation = ref.additionalQuickReplaceFieldsWithDefaultImplementation, additionalQuickReplaceFieldsWithDefaultImplementation = _additionalQuickReplaceFieldsWithDefaultImplementation === void 0 ? {} : _additionalQuickReplaceFieldsWithDefaultImplementation, _rowSelector = ref.rowSelector, rowSelector = _rowSelector === void 0 ? getRowTextValue : _rowSelector;
    var quickReplaceFields = _toConsumableArray(defaultQuickReplaceFields).concat(_toConsumableArray(additionalQuickReplaceFields));
    var quickReplaceFieldsWithDefaultImplementation = _objectSpread({}, defaultQuickReplaceFieldsWithDefaultImplementation, additionalQuickReplaceFieldsWithDefaultImplementation);
    cart.forEach(function(item) {
        item.rows.forEach(function(row) {
            var _options;
            var tag = ((_options = row.options) !== null && _options !== void 0 ? _options : {}).tag;
            if (!tag) {
                return;
            }
            var rowValue = item.values[row.id];
            var tags = tag.split(",").map(function(v) {
                return v.trim();
            });
            tags.forEach(function(tag) {
                if (quickReplaceFields.includes(tag)) {
                    newHtml = tagReplacer(newHtml, tag, rowSelector(rowValue));
                }
                var customSow = /^<?customSow\d+>?$/.exec(tag);
                if (customSow) {
                    newHtml = tagReplacer(newHtml, tag, rowSelector(rowValue));
                }
            });
        });
    });
    Object.entries(quickReplaceFieldsWithDefaultImplementation).forEach(function(param) {
        var _param = _slicedToArray(param, 2), tag = _param[0], f = _param[1];
        newHtml = tagReplacer(newHtml, tag, f(cart));
    });
    newHtml = tagReplacer2(newHtml, "customSow\\d+", "", {
        tagIsRegex: true
    });
    return newHtml;
};
